import React from 'react';
import { PingCommoditiesNavbar } from './PingCommoditiesNavbar';

const PingCommoditiesLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <PingCommoditiesNavbar />
      <div style={{ flex: 1 }}>{children}</div>
    </div>
  );
};

export default PingCommoditiesLayout;
